/**
 * QR-1b: ручки владельца по приглашению и участникам (тикет QR-1 §3.4) —
 * зеркало харнесса `tools/msg5-harness/node/api.mjs` (inviteMe/inviteEnsure/
 * inviteRotate/inviteRevoke/members/removeMember). Транспорт — axiosInstance
 * ЛК (owner-JWT, интерсептор обновляет протухший токен), X-Device-Id
 * браузера — как на остальных /msg-вызовах (модель MSG-3; инвайт-ручкам он
 * не обязателен, шлём для единообразия актора).
 *
 * Токен приглашения в ответах сервера — это креденциал входа в комнату
 * (§3.3): страница показывает его только в составе URL/QR, в логи не пишет.
 */
import axiosInstance from '../utils/router/axiosInstance';
import { browserDeviceId } from './deviceId';
import { MsgApiError } from './msgApi';

function toMsgError(e, path) {
  if (e?.response) {
    return new MsgApiError(e.response.status, e.response.data?.detail ?? e.response.data, path);
  }
  return e;
}

async function req(method, path, body) {
  try {
    const { data } = await axiosInstance.request({
      method, url: path, data: body, headers: { 'X-Device-Id': browserDeviceId() },
    });
    return data;
  } catch (e) {
    throw toMsgError(e, path);
  }
}

/** Активное приглашение {id, token, url, label, use_count, created_at} или null (404). */
export async function getMyInvite() {
  try {
    return await req('get', 'msg/invites/me');
  } catch (e) {
    if (e instanceof MsgApiError && e.status === 404) return null;
    throw e;
  }
}

/** ensure: есть активное -> 200 оно же (label игнорируется), нет -> 201 новое. */
export function ensureInvite(label) {
  return req('post', 'msg/invites/me', { label });
}

/** Отозвать активное (если есть) + выпустить новое одной транзакцией;
 *  label null -> подпись наследуется. */
export function rotateInvite(label = null) {
  return req('post', 'msg/invites/me/rotate', label == null ? {} : { label });
}

/** Отозвать: участники остаются. 404 (нечего отзывать) — тоже «готово». */
export async function revokeInvite() {
  try {
    await req('delete', 'msg/invites/me');
  } catch (e) {
    if (!(e instanceof MsgApiError && e.status === 404)) throw e;
  }
}

/** Мои активные участники [{id, display_name, created_at, invite_id, conversation_id}]. */
export async function listMembers() {
  const out = await req('get', 'msg/members');
  return Array.isArray(out?.members) ? out.members : [];
}

/** Удалить участника (purge переписки, его токен -> 401). */
export function removeMember(memberId) {
  return req('delete', `msg/members/${encodeURIComponent(memberId)}`);
}
